import React, { useState } from 'react';
import DropdownSelect from './DropdownSelect';
import NumberStepper from './NumberStepper';

const EQUIPMENT_OPTIONS = [
  { model: 'QSB6.7', type: 'diesel generator' },
  { model: 'QSL9', type: 'construction equipment' },
  { model: 'QSX15', type: 'power generation' },
  { model: 'B6.7', type: 'medium-duty truck' },
  { model: 'X15', type: 'heavy-duty truck' },
  { model: 'QSK60', type: 'mining equipment' },
].map(({ model, type }) => ({ value: model, label: `${model} — ${type}` }));

const COMMON_FAULT_CODES = [
  'P0217', 'P0115', 'P0128', 'P0562', 'P0563', 'P0620',
  'P0087', 'P0088', 'P0251', 'P2002', 'P20EE', 'P2201',
  'P0520', 'P0524', 'P0300', 'P0335', 'P0100', 'P0110',
];

function TicketForm({ onSubmit, loading }) {
  const [formData, setFormData] = useState({
    technician_id: 'TECH-0017',
    technician_name: 'Alex Rivera',
    equipment_model: '',
    equipment_type: '',
    model_year: 2019,
    operating_hours: 4200,
    fault_code: '',
    symptoms: '',
  });

  const handleEquipmentChange = (model) => {
    const selected = EQUIPMENT_OPTIONS.find((eq) => eq.value === model);
    const type = selected?.label?.split(' — ')[1] || '';
    setFormData({
      ...formData,
      equipment_model: model || '',
      equipment_type: type,
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNumberChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.equipment_model || !formData.fault_code || !formData.symptoms) return;
    onSubmit(formData);
  };

  return (
    <div className="form-page">
      <div className="form-page__card card">
        <h2 className="form-page__title">New Service Ticket</h2>
        <p className="form-page__subtitle">
          Enter fault information to begin AI-assisted troubleshooting
        </p>

        <form onSubmit={handleSubmit} className="form form--spaced">
          {/* Equipment Selection */}
          <div className="form-group">
            <DropdownSelect
              label="Equipment"
              name="equipment_model"
              options={EQUIPMENT_OPTIONS}
              value={formData.equipment_model}
              onChange={handleEquipmentChange}
              placeholder="Select equipment model..."
              required
            />
          </div>

        {/* Year and Hours */}
        <div className="form-row">
          <div className="form-group">
            <NumberStepper
              label="Model Year"
              name="model_year"
              value={formData.model_year}
              onChange={(v) => handleNumberChange('model_year', v)}
              min={2010}
              max={2025}
              step={1}
              required
            />
          </div>
          <div className="form-group">
            <NumberStepper
              label="Operating Hours"
              name="operating_hours"
              value={formData.operating_hours}
              onChange={(v) => handleNumberChange('operating_hours', v)}
              min={0}
              max={999999}
              step={1}
              required
            />
          </div>
        </div>

        {/* Fault Code */}
        <div className="form-group">
          <DropdownSelect
            label="Fault Code"
            name="fault_code"
            options={COMMON_FAULT_CODES}
            value={formData.fault_code}
            onChange={(code) => setFormData({ ...formData, fault_code: code })}
            placeholder="Select or enter fault code..."
            required
          />
        </div>

        {/* Symptoms */}
        <div className="form-group">
          <label className="form-label">Symptoms</label>
          <textarea
            className="form-textarea"
            name="symptoms"
            value={formData.symptoms}
            onChange={handleChange}
            placeholder="Describe what you're observing... (e.g., engine overheating, visible steam, warning lights)"
            required
          />
        </div>

        {/* Submit */}
        <button
          className={`btn btn--primary btn--block ${loading ? 'btn--loading' : ''}`}
          type="submit"
          disabled={loading || !formData.equipment_model || !formData.fault_code || !formData.symptoms}
        >
          {loading ? (
            <span className="btn__spinner-wrap">
              <span className="btn__spinner" aria-hidden />
              <span>Analyzing...</span>
            </span>
          ) : (
            'Submit & Analyze'
          )}
        </button>
        </form>
      </div>
    </div>
  );
}

export default TicketForm;
